import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/jiese';

const footerLinks = [
  {
    title: '内容分类',
    links: categories.map((c) => ({ name: c.name, path: `/category/${c.slug}` })),
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '隐私政策', path: '/about' },
    ],
  },
  {
    title: '实用资源',
    links: [
      { name: '戒色打卡', path: '/category/jiese-daka' },
      { name: '成功案例', path: '/category/chenggong-anli' },
      { name: '常见问题', path: '/#faq' },
    ],
  },
];

export default function Footer() {
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  return (
    <footer className="bg-secondary-100 border-t border-background-200/60">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-lg font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              戒色完全指南
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              科学戒色方法研究与传播平台，帮助每一位来访者实现身心健康和人生重建。
            </p>
          </div>

          {/* Link Groups */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <button
                      onClick={() => handleClick(link.path)}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 戒色完全指南. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500">
            本网站内容仅供健康参考，不构成医疗建议。
          </p>
        </div>
      </div>
    </footer>
  );
}